module.exports = __webpack_public_path__ + "img/1.ebe18288.jpg";